import VulnerabilitiesGrid from './VulnerabilitiesGrid';

export default VulnerabilitiesGrid;
